module.exports = __webpack_public_path__ + "static/media/professional-demonstration.33824190.svg";